import {  SearchField, shadowStandard, YStack } from '@my/ui'
import { SectionTitle } from 'app/components'
import React, { useState } from 'react'
import { SearchBlock } from './search.block'
import { useRouter } from 'solito/router'

interface SearchComponentProps extends Partial<SearchBlock> {
  heading?: string
}

export const SearchComponent = (props: SearchComponentProps) => {
  const [query, setQuery] = useState('')
  const onSearchChange = (value) => {
    setQuery(value)
  }
  const { push } = useRouter()

  const handleEnter = (event) => {
    const value = event.target ? event.target.value : event
    push(`/search?query=${encodeURIComponent(value)}`)
  }
  const title = props.title || props.heading

  return (
    <YStack
      gap="$3.5"
      width="100%"
      br="$3"
      bg="$white"
      p="$5"
      $gtSm={{ gap: '$6', p: '$6' }}
      {...shadowStandard}
    >
      {title && (
        <SectionTitle tag="h1" textAlign="center">
          {title}
        </SectionTitle>
      )}
      <SearchField
        width="100%"
        maxWidth={580}
        mx="auto"
        h={50}
        inputProps={{
          placeholder: 'Search Items, Brands, Shops and more!',
        }}
        onSearchChange={onSearchChange}
        value={query}
        onSubmit={handleEnter}
      />
    </YStack>
  )
}
